 


//jQuery(document).ready(function($) {
 var linksTomenu1 = $('a[href="/collections/mens-insulated-synthetic-jackets"]');
  var linksTomenu2 = $('a[href="/collections/mens-insulated-down-jackets"]');
  var linksTomenu3 = $('a[href="/collections/womens-insulated-down-jackets"]');
  var linksTomenu4 = $('a[href="/collections/womens-insulated-synthetic-jackets"]');
  
  $(linksTomenu1).closest('li').css({"list-style": "disc"}).animate({marginLeft: "+=26px"});
  $(linksTomenu2).closest('li').css({"list-style": "disc"}).animate({marginLeft: "+=26px"});
  
  $(linksTomenu3).closest('li').css({"list-style": "disc"}).animate({marginLeft: "+=26px"});
  $(linksTomenu4).closest('li').css({"list-style": "disc", "white-space": "nowrap"}).animate({marginLeft: "+=26px"});

   // var linksTomenu5 = $('a[href="/collections/clearance-30-off"]');
 //$(linksTomenu5).closest('li').css({"list-style": "disc"}).animate({marginLeft: "+=26px"});
//  $(linksTomenu5).css('border','1px solid transparent')
//$('.custom-class-parent').css('border','2px solid transparent');
 

  
  
$("li .customclass:contains(Synthetic Jackets)").css({"list-style": "disc"});
jQuery(".nav-mega-section-list>li>a:contains(Down Jackets)").closest('li').css({"list-style": "disc", "margin-left": "26px"})
 
 


var linksTomenu5 = $('h5 a[href="/collections/mens-footwear"]'); 
   $(linksTomenu5).closest('div').addClass('widthlimit');
